module.exports = __webpack_public_path__ + "img/hzfp34.a983317e.png";